(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["review"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const btn = document.querySelector('.toggle-div-section .toggle-btn');
    const div = document.querySelector('.toggle-div-section .toggle-content');
    const showText = "Show Review";
    const hideText = "Hide Review";

    btn.addEventListener('click', () => {
      if (div.style.display === 'none' || div.style.display === '') {
        div.style.display = 'block';
        btn.textContent = hideText;
      } else {
        div.style.display = 'none';
        btn.textContent = showText;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
